// Which entries inside a series zip are DICOM instances, and which files a user
// may pick for a radiology upload.
//
// Real-world DICOM rarely uses the .dcm suffix: PACS exports are usually
// extensionless (IM000001) or named after the SOP Instance UID
// (1.2.840.113704.1.111...). Filtering on ".dcm" alone silently drops every
// slice of a real exam.
//
// Keep this rule in sync with is_dicom_candidate() in
// backend/app/services/dicom_ingest.py.

export const DICOM_EXTENSIONS = [".dcm", ".ima"];

// Files named after their SOP Instance UID: digits separated by dots.
const UID_NAME = /^[0-9]+(\.[0-9]+)+$/;

export const basenameOf = (name = "") => name.split("/").pop() || "";

/** True if a zip entry / file name could be a DICOM instance. */
export function isDicomEntryName(name = "") {
  if (!name || name.endsWith("/")) return false;
  if (name.includes("__MACOSX/")) return false;

  const base = basenameOf(name);
  // Covers ._resource forks, .DS_Store and other hidden files.
  if (!base || base.startsWith(".")) return false;
  if (base.toUpperCase() === "DICOMDIR") return false;

  const lower = base.toLowerCase();
  if (DICOM_EXTENSIONS.some((ext) => lower.endsWith(ext))) return true;
  if (UID_NAME.test(base)) return true;
  return !base.includes(".");
}

/** True if the user's pick is a zip archive rather than a bare instance. */
export const isZipName = (name = "") => name.toLowerCase().endsWith(".zip");
